import type {
  FeaturedProductListInput,
  PublicCategoryListInput,
  PublicProductListInput,
} from './types';

const clean = <T extends object>(input: T) =>
  Object.fromEntries(
    Object.entries(input)
      .filter(([, value]) => value !== undefined)
      .sort(([a], [b]) => a.localeCompare(b)),
  );

export const catalogKeys = {
  // Increment when cached catalog response/view-model compatibility changes.
  all: ['catalog', 'public-v2'] as const,
  categories: () => [...catalogKeys.all, 'categories'] as const,
  categoryList: (input: PublicCategoryListInput = {}) =>
    [...catalogKeys.categories(), 'list', clean(input)] as const,
  category: (slug: string) => [...catalogKeys.categories(), 'detail', slug] as const,
  products: () => [...catalogKeys.all, 'products'] as const,
  productList: (input: PublicProductListInput = {}) =>
    [...catalogKeys.products(), 'list', clean(input)] as const,
  categoryProducts: (categorySlug: string, input: PublicProductListInput = {}) =>
    [...catalogKeys.products(), 'category', categorySlug, clean(input)] as const,
  product: (slug: string) => [...catalogKeys.products(), 'detail', slug] as const,
  featuredProducts: (input: FeaturedProductListInput = {}) =>
    [...catalogKeys.products(), 'featured', clean(input)] as const,
};
